import { type APIUser } from '@alternativamais/chat-core';

import { Avatar } from '../../../componentes/Avatar';
import { Icone } from '../../../componentes/Icone';
import { abrirCamada } from '../../../chat/camadas';
import { useEstado } from '../../../chat/contexto';
import { useNome } from '../../../chat/ganchos';

/** Membros do grupo (D4), à direita; o dono com a coroa. */
export function MembrosGrupo({ canalId }: { canalId: string }) {
  const canal = useEstado((estado) => estado.channels[canalId]);
  const eu = useEstado((estado) => estado.me);
  if (!canal) return null;
  const membros = [...(eu ? [eu] : []), ...(canal.recipients ?? [])];
  return (
    <aside
      aria-label="Membros do grupo"
      className="flex w-60 shrink-0 flex-col bg-lateral"
    >
      <h3 className="m-0 px-4 pt-6 pb-1 text-xs font-semibold tracking-[.04em] text-texto-3 uppercase">
        Membros — {membros.length}
      </h3>
      <ul className="rolagem m-0 flex list-none flex-col overflow-y-auto px-2">
        {membros.map((pessoa) => (
          <Membro
            key={pessoa.id}
            pessoa={pessoa}
            dono={canal.owner_id === pessoa.id}
          />
        ))}
      </ul>
    </aside>
  );
}

function Membro({ pessoa, dono }: { pessoa: APIUser; dono: boolean }) {
  const nome = useNome(pessoa.id, null, pessoa);
  const status = useEstado(
    (estado) => estado.presences[pessoa.id]?.status ?? 'offline',
  );
  return (
    <li>
      <button
        type="button"
        onClick={(evento) => {
          const caixa = evento.currentTarget.getBoundingClientRect();
          abrirCamada({
            tipo: 'perfil',
            userId: pessoa.id,
            guildId: null,
            ancora: { x: caixa.left - 8, y: caixa.top },
          });
        }}
        className={`flex h-[42px] w-full items-center gap-2.5 rounded-md px-2 text-left hover:bg-hover ${
          status === 'offline' ? 'opacity-50 hover:opacity-100' : ''
        }`}
      >
        <Avatar
          pessoa={pessoa}
          nome={nome}
          tamanho={32}
          status={status}
          fundo="var(--cor-lateral)"
        />
        <span className="truncate text-[15px] font-medium text-texto-2">
          {nome}
        </span>
        {dono && (
          <span title="Dono do grupo" className="shrink-0 text-ausente">
            <Icone nome="coroa" tamanho={14} />
          </span>
        )}
      </button>
    </li>
  );
}
